import { useState } from 'react';
import { Boton, Campo, ENTRADA } from './ui';
import { ORIGEN_PUBLICO } from '../nucleo/sitio';

/** El PIN queda solo en memoria; compartir de nuevo no genera otro. */
export function InvitacionOrganizador({ club, nombre, pin }: { club: string; nombre: string; pin: string }) {
  const [aviso, setAviso] = useState('');
  const mensaje = `¡Hola, ${nombre}! Te invito a organizar los torneos de ${club}.\n\nEntrá acá: ${ORIGEN_PUBLICO}/admin\nNombre: ${nombre}\nPIN provisorio: ${pin}\n\nAl entrar, la página te va a pedir que elijas tu propio PIN.\n\nGuía paso a paso para preparar y manejar tu torneo:\n${ORIGEN_PUBLICO}/guia-organizador\nPodés leerla sin iniciar sesión. Después la encontrás siempre en «Guía de uso», dentro del panel.`;
  const copiar = async () => {
    try { await navigator.clipboard.writeText(mensaje); setAviso('Invitación copiada.'); }
    catch { setAviso('No se pudo copiar. Seleccioná el mensaje y copialo manualmente.'); }
  };
  return <section className="mt-3 rounded-xl border border-(--color-acento) p-3">
    <Campo etiqueta={`Invitación para ${nombre}`}>
      <textarea readOnly rows={12} className={`${ENTRADA} py-3`} value={mensaje} onFocus={e => e.currentTarget.select()} />
    </Campo>
    <div className="mt-3 flex flex-wrap items-center gap-2">
      <a className="inline-flex min-h-11 items-center rounded-xl bg-(--color-acento) px-4 font-semibold text-(--color-sobre-acento)" href={`https://wa.me/?text=${encodeURIComponent(mensaje)}`} target="_blank" rel="noopener noreferrer" referrerPolicy="no-referrer">Enviar por WhatsApp</a>
      <Boton chico tipo="secundario" onClick={() => void copiar()}>Copiar invitación</Boton>
    </div>
    <p className="mt-2 text-xs text-(--color-apagado)">Guardá o enviá esta invitación antes de salir de la página.</p>
    {aviso && <p role="status" className="mt-2 text-sm">{aviso}</p>}
  </section>;
}
